/**
 * Thin wrapper around window.location navigation.
 * Extracted as a named export so it can be spied on in tests,
 * since jsdom does not support direct reassignment of window.location.href.
 */
export const navigateTo = (url: string): void => {
  window.location.href = url;
};
